exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2W1II6XZE41B-omLpG8beW{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow:hidden}html[dir] ._2W1II6XZE41B-omLpG8beW{padding-top:2px}._7UR-fY9jBBQEFSk8jmUSa{font-weight:600;font-size:12px;font-weight:400;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}html[dir=ltr] ._2y2G1kT199HMF0QhiOVbTp{padding-right:5px}html[dir=rtl] ._2y2G1kT199HMF0QhiOVbTp{padding-left:5px}", ""]);
// Exports
exports.locals = {
	"personContainer": "_2W1II6XZE41B-omLpG8beW",
	"personaName": "_7UR-fY9jBBQEFSk8jmUSa",
	"personaControlContainer": "_2y2G1kT199HMF0QhiOVbTp"
};